import {Component, Vue, Prop} from "vue-property-decorator";

@Component
export class MultipleSelect extends Vue {

  @Prop({ type: Array, required: true }) dictionary;
  @Prop({ type: String, default: null }) nullLabel;
  @Prop({ type: Boolean, default: false }) disabled;
  @Prop({ type: Boolean, default: false }) multiple;
  @Prop({
    type: Function,
    required: false,
    default: (a, b) => a === b
  }) equalsFunction;
  @Prop({ type: Function, required: false, default: v => v }) labelFunction;
  @Prop() value;

  get selectedIndexes() {
    return this.value && this.dictionary.reduce((acc, o, i) => {
      if (this.value.find(v => this.equalsFunction(v, o))) acc.push(i);
      return acc;
    }, []);
  }

  handleInputChange(e) {

    const { options } = e.target;
    const selectedIndexes = [];

    for (const option of options) {
      if (option.value !== -1 && option.selected) {
        selectedIndexes.push(parseInt(option.value));
      }
    }

    this.$emit("change", this.dictionary.filter((o, i) => selectedIndexes.includes(i)));
  }

  render() {
    return (
      <div class="select is-small is-multiple">
        <select onChange={this.handleInputChange} disabled={this.disabled} multiple >
          {this.nullLabel && (
            <option value="-1" selected={!this.selectedIndexes || this.selectedIndexes.length === 0 ? true : undefined}>
              {this.nullLabel}
            </option>
          )}
          {this.dictionary.map((v, i) => (
            <option value={i} selected={this.selectedIndexes && this.selectedIndexes.indexOf(i) !== -1 ? true : undefined} >
              {this.labelFunction(v)}
            </option>
          ))}
        </select>
      </div>

    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-73da6ea3/multiple-select.tsx" });